import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import {
  IntegrationEnum,
  IntegrationStatus,
} from 'models/InternalIntegrationSetting';
import useAppUser from '../../../../hooks/useAppUser';
import useRefreshOnHostfullyIntegrationEvent from './useRefreshOnHostfullyIntegrationEvent';

const useGuidebooks = () => {
  const { isEmployeeManager } = useAppUser();
  const { data, refetch } = useFetchIntegrationAgencySettings({
    enumId: IntegrationEnum.HOSTFULLY,
    enabled: isEmployeeManager,
  });

  useRefreshOnHostfullyIntegrationEvent({ refreshFn: refetch });

  const isGuidebooksEnabled =
    (isEmployeeManager &&
      data?.agencySettings?.status === IntegrationStatus.ACTIVE) ||
    false;

  return { isGuidebooksEnabled };
};

export default useGuidebooks;
